'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { List } from 'foundations-components/transitional/components/List';
import { BookIcon, LessonIcon, WebsiteIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useLeadGenContext } from '../../../../context/LeadGenContext';
import { getEventSelectorId } from '../../../../utils/analytics';
import { getFormattedUrl } from '../../../../utils/urls';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PATH = 'appMarketplace.detail.overview.sidebar.resources';
const Resources = ({
  casesUrl,
  onTrackInteraction,
  setupUrl,
  companyUrl
}) => {
  const {
    runLeadGen
  } = useLeadGenContext();
  const trackInteraction = useCallback(action => onTrackInteraction(action, {
    section: 'resources'
  }), [onTrackInteraction]);
  return /*#__PURE__*/_jsxs(List, {
    wrapChildren: true,
    children: [/*#__PURE__*/_jsx(Button, {
      use: "link",
      "data-hs-analytics-id": getEventSelectorId('SIDEBAR-SETUP-GUIDE'),
      external: true,
      hideExternalLinkIcon: true,
      href: getFormattedUrl(setupUrl),
      onClick: () => trackInteraction('click setup guide link'),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(LessonIcon, {
          color: "icon-core-subtle"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.setupGuideLinkText`
        })]
      })
    }), companyUrl && /*#__PURE__*/_jsx(Button, {
      use: "link",
      "data-hs-analytics-id": getEventSelectorId('SIDEBAR-COMPANY'),
      external: true,
      href: getFormattedUrl(companyUrl),
      hideExternalLinkIcon: true,
      onClick: () => {
        runLeadGen({
          onTrackInteraction,
          section: 'resources'
        });
        trackInteraction('click company website link');
      },
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(WebsiteIcon, {
          color: "icon-core-subtle"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.companyWebsiteLinkText`
        })]
      })
    }), casesUrl && /*#__PURE__*/_jsx(Button, {
      use: "link",
      external: true,
      href: getFormattedUrl(casesUrl),
      hideExternalLinkIcon: true,
      onClick: () => trackInteraction('click case study link'),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(BookIcon, {
          color: "icon-core-subtle"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${I18N_PATH}.caseStudyLinkText`
        })]
      })
    })]
  });
};
Resources.propTypes = {
  casesUrl: PropTypes.string,
  onTrackInteraction: PropTypes.func.isRequired,
  setupUrl: PropTypes.string.isRequired,
  companyUrl: PropTypes.string
};
export default Resources;